<template>
	<div>
		<v-dialog v-model="dialog_quill" scrollable fullscreen persistent :overlay="false" max-width="500px" no-click-animation transition="slide-y-transition">
	    	<v-card class="print-field-content" flat style="padding-top:68px !important;padding-bottom:68px !important;">
                <v-toolbar flat fixed class="main_toolbar">
                    <v-toolbar-side-icon @click="$parent.fn_closeDialog"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
                    <v-toolbar-title :class="{'two-line-title':$parent.Form.name}">
                        Content
                        <div class="toolbar-subtitle" v-if="$parent.Form.name">
                            <div class="subtitle-text dark-opacity-color">
                                {{$parent.Form.name}}
                            </div>
                        </div>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="$parent.fn_resetFieldContent">Reset</v-btn>
                    <v-menu style="z-index:999">
                        <v-btn icon slot="activator" :ripple="false"><v-icon>more_vert</v-icon></v-btn>
                        <v-list nopadding>
                            <v-list-tile @click="$parent.fn_openDialogSignature">
                               <v-list-tile-title>Add Signature</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="fn_pickSignature">
                               <v-list-tile-title>Upload Signature</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="$parent.fn_openDialogBankDetails">
                               <v-list-tile-title>Add Bank Details</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="$parent.bottomSheet=true">
                               <v-list-tile-title>Add Fields</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                    <!-- <v-btn flat icon color="primary" @click="fn_saveContent"><v-icon>done</v-icon></v-btn> -->
                </v-toolbar>
                <quill-editor class="hasFoooterBtn" ref="myTextEditor"
                    data-no-translate
                    v-model="content"
                    :options="editorOption"
                    @blur="onEditorBlur($event)"
                    @focus="onEditorFocus($event)"
                    @ready="onEditorReady($event)">
                    <div id="toolbar" slot="toolbar">
                        <!-- Add a bold button -->
                        <button class="ql-bold">Bold</button>
                        <button class="ql-italic">Italic</button>
                        <button class="ql-underline">ql-underline</button>
                        <button class="ql-strike">Italic</button>
                        <!-- Add ordered/bullet list -->
                        <button class="ql-list" value="ordered">ql-list</button>
                        <button class="ql-list" value="bullet">ql-list</button>

                        <!-- You can also add your own -->
                        <!-- <button id="custom-button" @click="fn_checkPermission" style="padding:0"><v-icon>insert_photo</v-icon></button> -->
                        <button id="custom-button" @click="fn_pickSignature('image_content')" style="padding:0"><v-icon>insert_photo</v-icon></button>

                        <!-- Add font size dropdown -->
                        <select class="ql-size">
                          <option value="small"></option>
                          <!-- Note a missing, thus falsy value, is used to reset to default -->
                          <option selected></option>
                          <option value="large"></option>
                          <option value="huge"></option>
                        </select>

                        
                    </div>
                </quill-editor>
                <!-- <v-btn flat color="primary" style="position:fixed;bottom:42px;background:#fff;right:0" nomargin @click="fn_previewContent"><v-icon color="primary" left>visibility</v-icon>Preview</v-btn> -->

                <div white-background full-width nopadding style="position:fixed;bottom:0;">
                    <v-layout row wrap style="background:#ddd;">
                        <v-flex xs6 sm6 md6>
                            <v-btn style="height:48px !important" nomargin block no-round-borders noshadow @click="fn_previewContent">Preview</v-btn>
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <v-btn style="height:48px !important" color="primary" nomargin block no-round-borders noshadow @click="fn_saveContent">Done</v-btn>
                        </v-flex>
                    </v-layout>
                </div>
            </v-card>
	    </v-dialog>

        <v-bottom-sheet v-model="$parent.bottomSheet">
            <!-- <v-sheet> -->
                <v-card>
                    <v-card-title primary-title>
                      Add Fields
                      <v-spacer></v-spacer>
                      <v-icon v-ripple @click="$parent.bottomSheet=false">close</v-icon>
                    </v-card-title>
                    <v-card-text style="max-height:200px;overflow:auto;padding-top:0">
                        <div v-for="(category, index) in keywords" :key="index">
                            <v-subheader nopadding>{{category.name}}</v-subheader>
                            <v-btn color="primary" tile outline v-for="(item, itemIndex) in category.items" :key="itemIndex" @click="fn_addKeyword(item.keyword)">
                                {{item.title}}<v-icon right color="primary">add</v-icon>
                            </v-btn>
                        </div>
                    </v-card-text>
                </v-card>
            <!-- </v-sheet> -->
        </v-bottom-sheet>
	</div>
</template>	 	

<script>

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
//import { position, offset } from 'caret-pos';

export default{
    props:['saveContent'],
	data(){	
		return{
			dialog_quill: false,
            content:'',
			editorOption: {
              modules: {
                toolbar: '#toolbar'
              }
            },
            keywords:[
                    {"name":"Business Fields", "items":[{"title":"Name", "keyword":"{{BusinessName}}"},{"title":"Address", "keyword":"{{BusinessAddress}}"},{"title":"State", "keyword":"{{BusinessState}}"}]}
                ]
		}
	},
	components: {
        quillEditor
    },
	methods: {
		openDialogWeb: function () {	
            // this.content = this.$parent.content;
            if(this.$root.CurrentBusiness && (this.$root.CurrentBusiness.GSTRegistrationStatus==1 || this.$root.CurrentBusiness.GSTRegistrationStatus==2)){
                this.keywords = [{"name":"Business Fields", "items":[{"title":"Name", "keyword":"{{BusinessName}}"},{"title":"Address", "keyword":"{{BusinessAddress}}"},{"title":"State", "keyword":"{{BusinessState}}"},{"title":"Gst Number", "keyword":"{{GSTIN}}"}]}]
            }
            else{
                this.keywords = [{"name":"Business Fields", "items":[{"title":"Name", "keyword":"{{BusinessName}}"},{"title":"Address", "keyword":"{{BusinessAddress}}"},{"title":"State", "keyword":"{{BusinessState}}"}]}]
            }
			this.dialog_quill = true;
		},
		closeDialogWeb: function () {
			this.dialog_quill = false;
		},
        fn_saveContent: function(){
            this.saveContent(this.content);
        },
        // fn_saveContent: function(){
        //     this.$parent.Form.content = this.content;
        //     this.$forceUpdate();
        //     this.$parent.fn_closeDialog();
        //     if(this.$route.query && this.$route.query.dialog){
        //         this.fn_checkValidations();
        //     }
        // },
		onEditorBlur(editor) {
            console.log('editor blur', editor);
        },
        onEditorFocus(editor) {
            console.log('editor focus', editor);
            console.log(editor.clientX);
            //this.getCaretPosition();
        },
        onEditorReady(editor) {
            console.log('editor ready', editor)
        },

        fn_checkPermission: function(){
            let self = this;
            this.getData('Storage', null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        self.fn_selectFile();
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_selectFile: function(){
            let self = this;
            this.getData('GetImage', null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_uploadResponse: function(image){
            console.log(image);
            // this.content += '<p><img src="data:image/jpg;base64,'+image+'" alt=""></p>';
            let dataUrl = "data:image/jpg;base64,"+image;
            let selectionRange = this.$refs['myTextEditor'].quill.getSelection(true);
            this.$refs['myTextEditor'].quill.insertEmbed(selectionRange.index, 'image', dataUrl);
        },

        fn_previewContent: function(){
            this.$parent.fn_preview(this.content, true);
        },

        fn_addKeyword: function(keyword){
            console.log(this.$refs['myTextEditor'].quill.getSelection());
            let selectionRange = this.$refs['myTextEditor'].quill.getSelection(true);
            this.$refs['myTextEditor'].quill.insertText(selectionRange.index, keyword);
            // let html = '<span>'+keyword+'</span>'
            // this.$refs['myTextEditor'].quill.clipboard.dangerouslyPasteHTML(selectionRange.index, html);
        },

        fn_embedSign: function(dataUrl){
            let selectionRange = this.$refs['myTextEditor'].quill.getSelection(true);
            this.$refs['myTextEditor'].quill.insertEmbed(selectionRange.index, 'image', dataUrl);
            // this.content += '<p>test</p>';
            // let self = this;
            // setTimeout(function(){
            //     self.content += '<p>test</p>';
            //     console.log(this.content);
            // },100);
            console.log(this.content);
        },

        fn_pickSignature: function(type){
            // pick image change is enabled in version no 105 from android's side
            if(this.$root.appVersion < 109){
                this.$eventHub.$emit('AppUpdateDialog');
				return;
            }
            
            let self = this;
            this.$root.fn_checkStoragePermission(function(){
                self.fn_selectSignature(type);
            });
        },

        fn_selectSignature: function(type){
            let self = this;
            this.getData('PickImage', null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        if(type == 'image_content'){
                            self.fn_uploadResponse(response);
                        }
                        else{
                            let imageUri = "data:image/jpg;base64,"+response;
                            self.$parent.fn_embedSignature(imageUri, true);
                        }
                        // let imageUri = "data:image/jpg;base64,"+response;
                        // self.$parent.fn_embedSignature(imageUri, true);
                    },
                    onError: function(error){
                        console.log(error);
                        if(error == 'size limit exceeds'){
                            self.showToast("Max file size limit is 1MB");
                        }
                    }
                }
            );
        },
	}
}
</script>

<style>
    .print-field-content .quill-editor{
        padding-bottom: 100px;
        background-color:#fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/print_fields/dialogs/dialog_quill.vue